// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  list(context, params) {
    context.commit("set_loading");
    context.commit("reset_error");
    const { sortBy, sortDesc, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null, null];

    let sort  = []

    for (let idx = 0; idx < sortBy.length; idx++) {
      const by = sortBy[idx];
      const desc = sortDesc[idx] ? "-" : "";
      sort.push(desc+by);
    }

    return new Promise(resolve => {
      const { search, type, filter } = params;
      NewApiService.get("purchase-order", {
        page: page,
        sort: sort.join(","),
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: search,
        type: type,
        filter: filter
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.pos);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  get(context, params){
    context.commit("set_loading");
    context.commit("reset_error");
    return new Promise((resolve, reject) => {
      NewApiService.get("purchase-order/"+params.id)
      .then(({data}) => {
        resolve(data);
      })
      .catch(({ response }) => {
        reject(response)
      })
      .finally(() => {
        context.commit("unset_loading")
      })
    })
  },
  getChanges (context, {id, sort}) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("purchase-order/"+id + "/changes", {sort: sort.join(',')})
      .then(({data}) => {
        resolve(data);
      })
      .catch(({ response }) => {
        reject(response)
      })
      .finally(() => {
        context.commit("unset_loading")
      })
    })
  },

  setCurrency(context, params){
    context.commit("reset_error");
    if(params && params.poId && params.currency){
      context.commit("set_loading");
      return new Promise((resolve, reject) => {
        NewApiService.post("purchase-order/"+params.poId+'/set-currency', {currency:params.currency})
        .then(({data}) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading")
        })
      });
    }
  },

  createOrUpdate(ctx, model) {
      ctx.commit("reset_error");
      return new Promise((resolve, reject) => {
        if(model.id) {
          NewApiService.put("purchase-order/"+model.id,model)
          .then(({data}) => {
              resolve(data)
          })
          .catch(({ response }) => {
              reject(response)
          });
        }else{
          NewApiService.post("purchase-order",model)
          .then(({data}) => {
              resolve(data)
          })
          .catch(({ response }) => {
              reject(response)
          });
        }
          
      });
  },

  update(ctx, model) {
      ctx.commit("reset_error");
      return new Promise((resolve, reject) => {
          NewApiService.put("purchase-order/"+model.id,model)
          .then(({data}) => {
              resolve(data)
          })
          .catch(({ response }) => {
              reject(response)
          });
      });
  },

  validate(ctx, model) {
    ctx.commit("reset_error");
    const {poId, sendMail} = model;
    return new Promise((resolve, reject) => {
        NewApiService.put("purchase-order/"+poId+"/validate", {sendMail})
        .then(({data}) => {
          console.log(data)
            resolve(data)
        })
        .catch(({ response }) => {
          reject(response)
        });
    });
  },

  receiveProduct(ctx, params) {
    const { poId, productId, locations, cost} = params;
    ctx.commit("reset_error");

    return new Promise((resolve, reject) => {
      NewApiService.put("purchase-order/"+poId+"/receive",{productId, locations, cost})
      .then(({data}) => {
          resolve(data)
      })
      .catch(({ response }) => {
          reject(response)
      });
    });
  },
  addPayment(ctx, params) {
    ctx.commit("reset_error");
    const { poId, model } = params;

    return new Promise((resolve, reject) => {
      NewApiService.post("purchase-order/"+poId+"/add-payment",model)
      .then(({data}) => {
          resolve(data)
      })
      .catch(({ response }) => {
          reject(response)
      });
    });
  },
  deletePayment(ctx, payment) {
    ctx.commit("reset_error");

    return new Promise((resolve, reject) => {
      NewApiService.delete("purchase-order-payment/"+payment.id)
      .then(({data}) => {
          resolve(data)
      })
      .catch(({ response }) => {
          reject(response)
      });
    });
  },

  createFromOrder(ctx, orderId) {
    ctx.commit("reset_error");

    return new Promise((resolve, reject) => {
        NewApiService.post("purchase-order/create-from-order/"+orderId)
        .then(({data}) => {
            resolve(data)
        })
        .catch(({ response }) => {
            reject(response)
        });
    });
  },

  delete(ctx, id) {
    ctx.commit("reset_error");
    return new Promise((resolve, reject) => {
      NewApiService.delete("purchase-order/"+id)
        .then(({data}) => {
            resolve(data)
        })
        .catch(( {response} ) => {
            reject(response)
        });
    });
  },

  cancel(ctx, id) {
    ctx.commit("reset_error");
    return new Promise((resolve, reject) => {
      NewApiService.get("purchase-order/"+id+"/cancel")
        .then(({data}) => {
            resolve(data)
        })
        .catch(( {response} ) => {
            reject(response)
        });
    });
  }

};
